import { render } from "./AccountsChangeList.vue?vue&type=template&id=db95d3dc&scoped=true"
import script from "./AccountsChangeList.vue?vue&type=script&lang=js"
export * from "./AccountsChangeList.vue?vue&type=script&lang=js"

import "./AccountsChangeList.vue?vue&type=style&index=0&id=db95d3dc&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db95d3dc"]])

export default __exports__